"use client";

import React from "react";
import { MapPin, Phone, Mail, Facebook, Twitter, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 animate-pulse rounded-md bg-foreground/10" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <NavigationMenu viewport={false} className="max-w-full justify-start">
      <NavigationMenuList className="flex-col items-start gap-2 space-x-0">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="w-full">
            <NavigationMenuLink asChild className="w-full justify-start bg-transparent px-0 py-1 text-foreground/70 transition-colors hover:bg-transparent hover:text-secondary focus:bg-transparent data-[active=true]:bg-transparent">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function FooterInfo() {
  const businessDescription = "NAVIS è il broker di riferimento per il noleggio di yacht a Ibiza. Offriamo una consulenza tecnica d'élite e una flotta selezionata per garantire esperienze nautiche senza compromessi nel Mediterraneo.";
  const address = "Marina Ibiza, Paseo Juan Carlos I, Ibiza";
  const phone = "+39 3202766022";
  const email = "info@navis-ibiza-barche.com";
  const socials = [{
    name: "Instagram",
    icon: Instagram,
    href: "#"
  }, {
    name: "Facebook",
    icon: Facebook,
    href: "#"
  }, {
    name: "Twitter",
    icon: Twitter,
    href: "#"
  }];
  return <section data-section-id="259801" id="footer" className="bg-background py-16 text-foreground border-t border-secondary/20">
      <div className="container mx-auto px-6 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-8">
          {}
          <div className="md:col-span-5 lg:col-span-4">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-8 w-auto text-foreground" />
            </Link>
            <p className="font-default mt-6 text-sm leading-relaxed text-foreground/70">
              {businessDescription}
            </p>
          </div>

          {}
          <div className="md:col-span-3 lg:col-span-4 lg:justify-self-center">
            <h3 className="font-default mb-6 text-lg font-bold tracking-wider uppercase text-secondary">
              COLLEZIONI
            </h3>
            <MenuProvider menu_id="37">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-4 lg:col-span-4 lg:justify-self-end">
            <h3 className="font-default mb-6 text-lg font-bold tracking-wider uppercase text-secondary">
              CONTATTI
            </h3>
            <ul className="flex flex-col gap-4 text-sm text-foreground/70">
              {address && <li className="flex items-start gap-3">
                  <MapPin className="mt-0.5 size-5 shrink-0 text-secondary" />
                  <span className="font-default">{address}</span>
                </li>}
              {phone && <li className="flex items-center gap-3">
                  <Phone className="size-5 shrink-0 text-secondary" />
                  <span className="font-default">{phone}</span>
                </li>}
              {email && <li className="flex items-center gap-3">
                  <Mail className="size-5 shrink-0 text-secondary" />
                  <span className="font-default">{email}</span>
                </li>}
            </ul>

            <div className="mt-8 flex items-center gap-4">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.name} data-index={i} to={social.href} className="rounded-md border border-secondary/30 p-2 text-secondary transition-all hover:bg-secondary hover:text-primary-foreground" aria-label={social.name}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 border-t border-secondary/10 pt-8 text-center text-xs tracking-widest uppercase text-foreground/40">
          <p className="font-default">
            &copy; {new Date().getFullYear()} NAVIS YACHT BROKER. DESIGN BY NAVIS.
          </p>
        </div>
      </div>
    </section>;
}